<template>
  <div>
    <hr-check
      :label="state.field.label"
      :placeholder="state.field.help?.placeholder"
      :helper="state.field.help?.hint"
      :value="state.field.value"
      :invalid="state.field.isInvalid"
      :errorMessage="state.field.fieldError"
      @input="updateValue"
    ></hr-check>
  </div>
</template>

<script>
import { reactive } from 'vue';
import HrCheck from '@/components/hr-check.vue';
import { validate } from '@/core/validation/validation';
export default {
  name: 'hr-check-field',
  components: {
    HrCheck,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value', 'focus'],
  setup(props, { emit }) {
    const state = reactive({
      field: props.modelValue,
    });

    function updateValue(value) {
      state.field.value = value;
      state.field.valueObj = { unformatted: value, value };
      state.field.fieldError = '';
      emit('focus', state.field);
      validateField();
      emit('update:model-value', state.field);
    }

    function validateField() {
      validate(state.field);
    }

    return {
      state,
      updateValue,
    };
  },
};
</script>
